module.exports = __webpack_public_path__ + "img/j3.dc361fbb.jpg";